var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{ref:"video",attrs:{"controls":"","src":_vm.src,"width":_vm.width,"height":_vm.height},on:{"play":_vm.play}})])}
var staticRenderFns = []

export { render, staticRenderFns }